import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'input',
  setup(__props) {

const input = ref('')

const handleEnter = () => {
  window.alert('엔터를 눌렀습니다.')
}

return { __sfc: true,input, handleEnter }
}

})